import { defineStore } from 'pinia'
import { useFetch } from '@vueuse/core'

export const useWishlistStore = defineStore('wishlist', {
  state: () => {
    return {
      hasWishlistAccepted: false,
      items: [],
      pendingItem: undefined,
      showWarning: false,
      wishlistToken: undefined,
    }
  },
  getters: {
    checkWishlistAccepted(state) {
      return () => {
        const status = localStorage.getItem('wishlistAccepted')
        state.hasWishlistAccepted = status === 'true'

        if (!state.hasWishlistAccepted) {
          return
        }
        this.fetchWishlistItems()
      }
    },
    getItems (state) {
      if (state.items.length === 0 && localStorage.getItem('wishlistItems')) {
        state.items = JSON.parse(localStorage.getItem('wishlistItems'))
      }
      return state.items
    },
    hasItem (state) {
      return (id) => state.items.some((item) => item == id)
    },
    getWishlistToken (state) {
      return () => {
        if (!state.wishlistToken) {
          state.wishlistToken = localStorage.getItem('wishlistToken')
        }
        return state.wishlistToken
      }
    }
  },
  actions: {
    async acceptWishlist () {
      localStorage.setItem('wishlistAccepted', 'true')
      this.hasWishlistAccepted = true

      await this.initWishlist()
      await this.addItem(this.pendingItem)
    },
    async initWishlist () {
      const { data, error } = await useFetch(`/api/v1/wishlist/create`)
        .get()
        .json()

      if (error.value) {
        return { error: error.value }
      }

      const response = data.value
      await this.updateWishlistData(response.data)
    },
    async fetchWishlistItems () {
      if (!this.wishlistToken) {
        this.getWishlistToken()
      }

      const { data, error } = await useFetch(`/api/v1/wishlist/${this.wishlistToken}`)
        .get()
        .json()

      if (error.value) {
        return { error: error.value }
      }
      const response = data.value
      await this.updateWishlistData(response.data)
    },
    hideWishlistWarning() {
      this.showWarning = false
      this.pendingItem = undefined
    },
    async addItem(id) {
      if (this.hasItem(id)) {
        return
      }
      const { data, error } = await useFetch(`/api/v1/wishlist/add/${id}?token=${this.wishlistToken}`)
        .post()
        .json()
      if (error.value) {
        return { error: error.value }
      }
      const response = data.value
      await this.updateWishlistData(response.data)
    },
    async setItems(items) {
      localStorage.setItem('wishlistItems', JSON.stringify(items))
      this.items = items
    },
    async setWishlistToken(token) {
      localStorage.setItem('wishlistToken', token)
      this.wishlistToken = token
    },
    async updateWishlistData(data) {
      if (data?.items !== undefined) {
        await this.setItems(data.items)
      }
      if (data?.wishlistToken !== undefined) {
        await this.setWishlistToken(data.wishlistToken)
      }
    },
    async showWishlistWarning(id) {
      this.pendingItem = id
      this.showWarning = true
    },
    async removeItem (id) {
      const { data, error } = await useFetch(`/api/v1/wishlist/remove/${id}?token=${this.wishlistToken}`)
        .post()
        .json()

      if (error.value) {
        return { error: error.value }
      }

      const response = data.value
      await this.updateWishlistData(response.data)
    },
  }
})
